import React from 'react';
import Modal from "../../Modal";

export default ({
    show,
    data,
    onClose,
    onSubmit,
    disabled,
}) => {

    return (
        <>
            <Modal
                show={show}
                footer
                data={data}
                disabled = {disabled}
                onSuccess={onSubmit}
                onClose={onClose}
                successText={"Delete"}
                title={"Remove special term"}
            >
                <p>Are you sure about that?</p>
            </Modal>
        </>
    )
};